/** @format */

import React from 'react';
import SuperAgent from 'superagent';
import update from 'immutability-helper';
import {
    COLOR_4C,
    LAMINATE_GLOSS_FINISH,
    PROOF_TYPE_ELECTRONIC,
    SUBSTRATE_WHITE_PLASTIC
} from 'frontier-constants';

export default ComponentContainer => {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                quotes: [
                    {
                        quoteId: Date.now(),
                        defaultOrder: {
                            proof_type_id: PROOF_TYPE_ELECTRONIC,
                            width: '',
                            length: '',
                            customer_label: '',
                            shape_id: '',
                            total_qty: '',
                            design_qty: '',
                            substrate_id: '',
                            laminate_id: '',
                            form_factor_id: ''
                        }
                    }
                ]
            };
        }

        handleChange = updateTarget => {
            this.setState(state => update(state, updateTarget));
        };

        handleAddQuote = ({id, ...defaultOrder}) => {
            this.setState(state =>
                update(state, {quotes: {$push: [{quoteId: Date.now(), defaultOrder}]}})
            );
        };

        handleDeleteQuote = deletedQuoteId => {
            const quoteIndex = this.state.quotes.findIndex(
                ({quoteId}) => quoteId === deletedQuoteId
            );
            if (quoteIndex > -1) {
                this.setState(state => update(state, {quotes: {$splice: [[quoteIndex, 1]]}}));
            }
        };

        render() {
            const props = {...this.props};

            props.onChange = this.handleChange;
            props.onAddQuote = this.handleAddQuote;
            props.onDeleteQuote = this.handleDeleteQuote;

            return <ComponentContainer {...props} {...this.state} />;
        }
    };
};
